import { z } from 'zod'

import { organizationIntegrationSchema } from './organizationIntegration'
import { venueSchema } from './venue'

export const appConfigSchema = z.object({
  venue: venueSchema,
  //   daySettings: z.array(daySettingSchema),
  integrations: z.array(organizationIntegrationSchema),
  stripePublishableKey: z.string().optional(),
})
